import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import PropTypes from "prop-types";
import React from "react";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function ConfirmationDialog(props) {
  function handleClose() {
    props.onClose();
  }

  function handleAgree() {
    props.onAgree();
  }

  function handleDisagree() {
    props.onDisagree();
  }

  return (
    <Dialog
      open={props.open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-labelledby="confirmation-dialog-title"
      aria-describedby="confirmation-dialog-description"
    >
      {props.title && (
        <DialogTitle id="confirmation-dialog-title">{props.title}</DialogTitle>
      )}
      <DialogContent>
        <DialogContentText id="confirmation-dialog-description">
          {props.message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleDisagree} color="secondary">
          {props.agreeButtonLabel}
        </Button>
        <Button onClick={handleAgree} color="primary">
          {props.disagreeButtonLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ConfirmationDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string,
  message: PropTypes.string.isRequired,
  agreeButtonLabel: PropTypes.string,
  disagreeButtonLabel: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onAgree: PropTypes.func.isRequired,
  onDisagree: PropTypes.func.isRequired,
};

ConfirmationDialog.defaultProps = {
  open: false,
  title: "",
  message: "",
  agreeButtonLabel: "Cancelar",
  disagreeButtonLabel: "Continuar",
  onClose: () => {},
  onAgree: () => {},
  onDisagree: () => {},
};

export default ConfirmationDialog;
